import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetAvailableSitesQueryData, IGetAvailableSitesQueryVars } from '../types';

export const GET_AVAILABLE_SITES_QUERY: TypedDocumentNode<IGetAvailableSitesQueryData, IGetAvailableSitesQueryVars> =
  gql`
    query getAvailableSitesQuery($input: AvailableSitesQueryInput!) {
      availableSitesQuery(input: $input) {
        sites {
          orgId
          siteId
          testCenterTypeCd
          title
          rid
        }
      }
    }
  `;
